export interface GeodatosFeatureCollection {
    type: 'FeatureCollection';
    features: any[];
}

const geodatosService = {
    async getCarabineros(bbox?: string): Promise<GeodatosFeatureCollection> {
        const query = bbox ? `?bbox=${bbox}` : '';
        const response = await fetch(`/geodatos/api/v1/carabineros/${query}`);
        if (!response.ok) throw new Error('Error fetching carabineros');
        return response.json();
    },
    async getBomberos(bbox?: string): Promise<GeodatosFeatureCollection> {
        const query = bbox ? `?bbox=${bbox}` : '';
        const response = await fetch(`/geodatos/api/v1/bomberos/${query}`);
        if (!response.ok) throw new Error('Error fetching bomberos');
        return response.json();
    },
    async getEducacionEscolar(bbox?: string): Promise<GeodatosFeatureCollection> {
        const query = bbox ? `?bbox=${bbox}` : '';
        const response = await fetch(`/geodatos/api/v1/educacion-escolar/${query}`);
        if (!response.ok) throw new Error('Error fetching educacion-escolar');
        return response.json();
    },
    async getEducacionParvularia(bbox?: string): Promise<GeodatosFeatureCollection> {
        const query = bbox ? `?bbox=${bbox}` : '';
        const response = await fetch(`/geodatos/api/v1/educacion-parvularia/${query}`);
        if (!response.ok) throw new Error('Error fetching educacion-parvularia');
        return response.json();
    },
    async getEducacionSuperior(bbox?: string): Promise<GeodatosFeatureCollection> {
        const query = bbox ? `?bbox=${bbox}` : '';
        const response = await fetch(`/geodatos/api/v1/educacion-superior/${query}`);
        if (!response.ok) throw new Error('Error fetching educacion-superior');
        return response.json();
    },
    async getSalud(bbox?: string): Promise<GeodatosFeatureCollection> {
        const response = await fetch('https://datos.gob.cl/api/3/action/datastore_search?resource_id=2c44d782-3365-44e3-aefb-2c8b8363a1bc&limit=10000');
        if (!response.ok) throw new Error('Error fetching salud');
        const data = await response.json();

        let minLon: number, minLat: number, maxLon: number, maxLat: number;
        if (bbox) {
            [minLon, minLat, maxLon, maxLat] = bbox.split(',').map(Number);
        }

        // Map CKAN datastore records to GeoJSON
        const features = data.result.records
            .filter((r: any) => r.Latitud && r.Longitud) // Enforce valid coordinates
            .map((r: any) => {
                const lon = parseFloat(r.Longitud.toString().replace(',', '.'));
                const lat = parseFloat(r.Latitud.toString().replace(',', '.'));
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [lon, lat]
                    },
                    properties: { ...r, lon, lat }
                };
            })
            .filter((f: any) => {
                if (!bbox) return true;
                const { lon, lat } = f.properties;
                return lon >= minLon && lon <= maxLon && lat >= minLat && lat <= maxLat;
            });

        return {
            type: 'FeatureCollection',
            features
        };
    }
};

export default geodatosService;
